import { ThemeUICSSObject } from 'theme-ui';
import { spacing } from '../util';

const text: Record<string, ThemeUICSSObject> = {
  default: {
    color: 'palette.text.primary',
    fontFamily: 'body',
    fontWeight: 'body',
    fontSize: 16,
    m: spacing(0),
    width: '100%',
  },
  title: {
    letterSpacing: 'heading',
    wordBreak: 'normal',
    color: 'title',
    fontFamily: 'heading',
    lineHeight: 'heading',
    fontWeight: 'heading',
  },
};

export default text;
